<template>
  <div class="errormessage">
    <span class="errormessage-emoji">{{ error.emoji }}</span>
    <p>{{ error.message }}</p>
  </div>
</template>

<script>
export default {
  props: {
    error: Object
  }
};
</script>

<style lang="scss">
.errormessage {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  text-align: center;
}

.errormessage-emoji {
  font-size: 3em;
}
</style>
